import React from 'react';
import styled from 'styled-components';
import LimitFilter from './LimitFilter';

interface Props {
  title: string;
}

const LimitTable = ({ title }: Props) => {
  return (
    <LimitFilter title={title}>
      <Table>
        <colgroup>
          <col />
          <col />
          <col />
        </colgroup>
        <thead>
          <tr>
            <ColTh>구분</ColTh>
            <ColTh>접수일</ColTh>
            <ColTh>권리종류</ColTh>
          </tr>
        </thead>
      </Table>
    </LimitFilter>
  );
};

export default LimitTable;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  line-height: 150%;
  table-layout: fixed;
`;

const ColTh = styled.th<{ $width?: number }>`
  width: ${({ $width }) => ($width ? `${$width}px` : '100%')};
  padding: 10px 12px;
  background: #f7f8fc;
  color: #616161;
  font-weight: 500;
  text-align: center;
  border-bottom: 1px solid #e1e2e4;
  border-top: 1px solid #e1e2e4;
  font-size: 13px;
  white-space: nowrap;

  &:not(:first-child) {
    border-left: 1px solid #e1e2e4;
  }
`;
